// import * as React from "react";
// import PropTypes from "prop-types";
// import { useSelect } from "@mui/base";
// import { styled } from "@mui/system";
// import Grid from "@mui/material/Grid";
// import { Link, useNavigate } from "react-router-dom";
// import Box from "@mui/material/Box";
// import Fade from "react-reveal/Fade";
// import { HashLink } from "react-router-hash-link";
// import { useTranslation } from "react-i18next";
// import { useProductContext } from "../../context/ProductContext";

// const grey = {
//   100: "#E7EBF0",
//   200: "#E0E3E7",
//   300: "#CDD2D7",
//   400: "#B2BAC2",
//   500: "#A0AAB4",
//   600: "#6F7E8C",
//   700: "#3E5060",
//   800: "#2D3843",
//   900: "#1A2027",
// };

// const Root = styled("div")`
//   font-size: 0.875rem;
//   position: relative;
//   display: inline-block;
//   vertical-align: baseline;
//   color: #000;
// `;

// const Toggle = styled("div")(
//   ({ theme }) => `

//   font-size: 0.875rem;
//   box-sizing: border-box;
//   min-height: calc(1.5em + 22px);
//  cursor:pointer;
//   background: var(--color, ${
//     theme.palette.mode === "dark" ? grey[900] : "#fff"
//   });

//   border-radius: 0.75em;
//   margin: 0.5em;
//   padding-top: 10px;
//   text-align: left;
//   line-height: 1.5;
//   color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
//   display: inline-flex;
//   align-items: center;
//   justify-content: center;
//   cursor: default;
//   transition: background-color 0.2s ease, box-shadow 0.2s ease;

//   & .placeholder {
//     opacity: 0.8;
//   }
//   `
// );

// const Listbox = styled("div")(
//   ({ theme }) => `

//   font-size: 0.875rem;
//   box-sizing: border-box;
//   padding: 5px;
//   margin: 0 0 0 0;
//   list-style: none;
//   height: auto;
//   transition: opacity 0.1s ease;
//   width: 100vw;
//   position: fixed;

//     left: 0;
//     right: 0;
//   box-shadow: ${
//     theme.palette.mode === "dark"
//       ? `0 5px 13px -3px rgba(0,0,0,0.4)`
//       : `0 5px 13px -3px ${grey[200]}`
//   };
//   background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
//   border-radius: 0.75em;
//   color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};

//   z-index: 1;
//   outline: 0px;

//   &.hidden {
//     opacity: 0;
//     visibility: hidden;
//     transition: opacity 0.1s 0.1s ease, visibility 0.1s 0.1s step-end;
//   }
//   `
// );
// function getWindowDimensions() {
//   const { innerWidth: width, innerHeight: height } = window;
//   return {
//     width,
//     height,
//   };
// }

// function CustomSelect2({ options, placeholder }) {
//   const { t, i18n } = useTranslation();
//   const { products } = useProductContext();
//   const listboxRef2 = React.useRef(null);
//   const [listboxVisible, setListboxVisible] = React.useState(false);
//   const { innerWidth: width, innerHeight: height } = window;
//   // console.log("width    ====", width);
//   const { getButtonProps, getListboxProps, getOptionProps, value } = useSelect({
//     listboxRef2,
//     options,
//   });

//   React.useEffect(() => {
//     if (listboxVisible) {
//       listboxRef2.current?.focus();
//     }
//   }, [listboxVisible]);

//   return (
//     <Root
//       onMouseOver={() => setListboxVisible(true)}
//       onMouseOut={() => setListboxVisible(false)}
//       onFocus={() => setListboxVisible(true)}
//       onBlur={() => setListboxVisible(false)}
//       style={{ position: "relative" }}
//     >
//       <Toggle
//         {...getButtonProps()}
//         style={{ "--color": value, cursor: "pointer" }}
//       >
//         <HashLink to="/products-shoe">
//           {value ?? <span className="placeholder">{placeholder ?? " "}</span>}
//         </HashLink>
//       </Toggle>
//       <Listbox
//         {...getListboxProps()}
//         className={listboxVisible ? "" : "hidden"}
//       >
//         <Grid
//           container
//           sx={{
//             py: 4,

//             display: "flex",
//             justifyContent: "center",
//             fontSize: "14px",
//             border: "1px solid black",
//           }}
//         >
//           {products.map((product, idx) => {
//             if (product.group === "shoe") {
//               return (
//                 <Grid
//                   item
//                   md={2}
//                   //   className={classes.itemsOnHover}
//                   // borderRight: idx !== product.length - 1 ? "1px solid lightgray" : null,
//                   sx={{
//                     flexDirection: "column",

//                     display: "flex",
//                     textAlign: "center",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Fade delay={200}>
//                     <HashLink to={"/product/" + product.linkTo}>
//                       <img
//                         className="animation"
//                         src={process.env.PUBLIC_URL + product.img}
//                         width="100"
//                         height="120"
//                         alt=""
//                       />
//                       <Box mt={1}>{t(product.title)}</Box>
//                       {/* <Box className={classes.popular}>Popular</Box> */}
//                     </HashLink>
//                   </Fade>
//                 </Grid>
//               );
//             }
//           })}
//         </Grid>
//       </Listbox>
//     </Root>
//   );
// }

// CustomSelect2.propTypes = {
//   options: PropTypes.arrayOf(
//     PropTypes.shape({
//       disabled: PropTypes.bool,
//       label: PropTypes.node,
//       value: PropTypes.string.isRequired,
//     })
//   ).isRequired,
//   placeholder: PropTypes.string,
// };

// const options = [
//   {
//     label: "Red",
//     value: "#D32F2F",
//   },
//   {
//     label: "Green",
//     value: "#4CAF50",
//   },
//   {
//     label: "Blue",
//     value: "#2196F3",
//   },
// ];

// export default function UseSelect() {
//   const { t, i18n } = useTranslation();
//   return (
//     <Box sx={{ cursor: "pointer" }}>
//       <CustomSelect2 placeholder={t("top_menu4")} options={options} />
//     </Box>
//   );
// }

import * as React from "react";
import PropTypes from "prop-types";
import { useSelect } from "@mui/base";
import { styled } from "@mui/system";
import Grid from "@mui/material/Grid";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Fade from "react-reveal/Fade";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import { useProductContext } from "../../context/ProductContext";

const grey = {
  100: "#E7EBF0",
  200: "#E0E3E7",
  300: "#CDD2D7",
  400: "#B2BAC2",
  500: "#A0AAB4",
  600: "#6F7E8C",
  700: "#3E5060",
  800: "#2D3843",
  900: "#1A2027",
};

const Root = styled("div")`
  font-size: 0.875rem;
  position: relative;
  display: inline-block;
  vertical-align: baseline;
  color: #000;
`;

const Toggle = styled("div")(
  ({ theme }) => `
 
  font-size: 0.875rem;
  box-sizing: border-box;
  min-height: calc(1.5em + 22px);
 cursor:pointer;
  background: var(--color, ${
    theme.palette.mode === "dark" ? grey[900] : "#fff"
  }); 
 
  border-radius: 0.75em;
  // margin: 0.5em;
  // padding-top: 10px;
  margin-left:20px;
  text-align: left;
  line-height: 1.5;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  & .placeholder {
    opacity: 0.8;
  }
  `
);

const Listbox = styled("div")(
  ({ theme }) => `
 
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 5px;   
  padding-top:0;
  margin: 0 0 0 0;
  list-style: none; 
  height: auto;
  transition: opacity 0.1s ease;
  width: 100%;  
  width: 100vw;
  position: absolute; 
 
    // left: -345px;
    // left: ${(window.innerWidth - 1600) / 2 - 275}px;
    // left: -320px;
    // right: 0;
    // left:0;

    left:-webkit-calc(100% - ${
      localStorage.getItem("language") === "en" ? "340px" : "290px"
    });
    left:-moz-calc(100% - ${
      localStorage.getItem("language") === "en" ? "340px" : "290px"
    });
    left:calc(100% - ${
      localStorage.getItem("language") === "en" ? "340px" : "290px"
    });
 
  box-shadow: ${
    theme.palette.mode === "dark"
      ? `0 5px 13px -3px rgba(0,0,0,0.4)`
      : `0 5px 13px -3px ${grey[200]}`
  };
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"}; 
  border-radius: 0.75em;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  overflow: auto;
  z-index: 1;
  outline: 0px;

  &.hidden {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s 0.2s ease, visibility 0.2s 0.2s step-end;
  }

 
  
  `
);
// alert(localStorage.getItem("language"));

function CustomSelect({ options, placeholder }) {
  const { t, i18n } = useTranslation();
  const { products } = useProductContext();
  const listboxRef = React.useRef(null);
  const [listboxVisible, setListboxVisible] = React.useState(false);

  const { getButtonProps, getListboxProps, getOptionProps, value } = useSelect({
    listboxRef,
    options,
  });

  React.useEffect(() => {
    if (listboxVisible) {
      listboxRef.current?.focus();
    }
  }, [listboxVisible]);

  return (
    <Root
      onMouseOver={() => setListboxVisible(true)}
      onMouseOut={() => setListboxVisible(false)}
      onFocus={() => setListboxVisible(true)}
      onBlur={() => setListboxVisible(false)}
    >
      <Toggle
        {...getButtonProps()}
        style={{ "--color": value, cursor: "pointer" }}
      >
        <HashLink to="/products-living">
          {value ?? <span className="placeholder">{placeholder ?? " "}</span>}
        </HashLink>
      </Toggle>
      <Listbox
        {...getListboxProps()}
        className={listboxVisible ? "" : "hidden"}
      >
        <Grid
          container
          sx={{
            py: 3,
            maxWidth: "1600px",
            display: "flex",
            justifyContent: "center",
            fontSize: "14px",
          }}
        >
          {products.map((product, idx) => {
            if (product.group === "living") {
              return (
                <Grid
                  item
                  md={2}
                  sx={{
                    flexDirection: "column",
                    display: "flex",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  <Fade delay={200}>
                    <Link to={"/product/" + product.linkTo}>
                      <img
                        className="animation"
                        src={process.env.PUBLIC_URL + product.img}
                        width="100"
                        height="120"
                        alt=""
                      />
                      <Box mt={2}>{t(product.title)}</Box>
                      {/* <Box className={classes.popular}>Popular</Box> */}
                    </Link>
                  </Fade>
                </Grid>
              );
            }
          })}
        </Grid>
      </Listbox>
    </Root>
  );
}

CustomSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      label: PropTypes.node,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
};

const options = [
  {
    label: "Red",
    value: "#D32F2F",
  },
  {
    label: "Green",
    value: "#4CAF50",
  },
  {
    label: "Blue",
    value: "#2196F3",
  },
];

export default function UseSelect() {
  const { t, i18n } = useTranslation();
  return <CustomSelect placeholder={t("top_menu4")} options={options} />;
}
